module.exports = __webpack_public_path__ + "img/bangzhu.6c3d72e0.png";